import React, { useState } from 'react';
import styled from 'styled-components';
import { colorBlackBase, colorSecondaryBase } from '@mediahuis/chameleon-theme-wl';
import { Paragraph, Flex, Box } from '@mediahuis/chameleon-react';
import { styles } from './styles/';
import ChatInfo from './ChatInfo';
import PhoneInfo from './PhoneInfo';
import EmailInfo from './EmailInfo';
import { STATUSES } from './enums';
var FakeLink = styled(Paragraph).withConfig({
  displayName: "Header__FakeLink",
  componentId: "sc-1mn0fn8-0"
})(["color:", ";transition:0.2s;"], colorBlackBase);
var OnHoverFlex = styled(Flex).withConfig({
  displayName: "Header__OnHoverFlex",
  componentId: "sc-1mn0fn8-1"
})(["&:hover ", "{text-decoration:underline;color:", ";cursor:pointer;}width:auto;"], FakeLink, colorSecondaryBase);
var Container = styled.div.withConfig({
  displayName: "Header__Container",
  componentId: "sc-1mn0fn8-2"
})(["border:1px solid #eee;background-color:#fff;z-index:999;border-top:0px;&:nth-child(1){border-top:1px solid #eee;}&:hover{cursor:pointer;}.boldCustomerServiceLink{font-weight:bold;}&:hover .boldCustomerServiceLink{text-decoration:underline;}"]);
var StatusIcon = styled.div.withConfig({
  displayName: "Header__StatusIcon",
  componentId: "sc-1mn0fn8-3"
})(["display:block;width:10px;height:10px;border-radius:50%;background-color:", ";margin-right:10px;"], function (props) {
  return props.isOnline ? styles.statusColors.active : styles.statusColors.inactive;
});
var ContentWrapper = styled.div.withConfig({
  displayName: "Header__ContentWrapper",
  componentId: "sc-1mn0fn8-4"
})(["position:relative;display:inline-block;"]);
var HoverableBoxItems = styled.div.withConfig({
  displayName: "Header__HoverableBoxItems",
  componentId: "sc-1mn0fn8-5"
})(["position:absolute;z-index:50;width:300px;right:", ";display:", ";"], function (props) {
  return props.dropdownAlignment === 'right' ? 0 : '';
}, function (props) {
  return props.isOpen ? 'block' : 'none';
});

var Header = function Header(_ref) {
  var _chat$output;

  var title = _ref.title,
      isOnline = _ref.isOnline,
      chat = _ref.chat,
      email = _ref.email,
      phone = _ref.phone,
      openChat = _ref.openChat,
      dropdownAlignment = _ref.dropdownAlignment,
      openPhone = _ref.openPhone,
      isChatbotRobbie = _ref.isChatbotRobbie;

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var isActive = function isActive(status) {
    switch (status) {
      case STATUSES.CLOSED:
      case STATUSES.HOLIDAY:
      case STATUSES.OPENSOON:
      case STATUSES.RESTDAY:
      case STATUSES.CHATBOT:
        return false;

      default:
        return true;
    }
  };

  return /*#__PURE__*/React.createElement(OnHoverFlex, {
    alignItems: "flex-end",
    flexDirection: "column",
    onMouseEnter: function onMouseEnter() {
      return setIsOpen(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsOpen(false);
    }
  }, /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(StatusIcon, {
    isOnline: isOnline
  }), /*#__PURE__*/React.createElement(FakeLink, null, title))), /*#__PURE__*/React.createElement(HoverableBoxItems, {
    dropdownAlignment: dropdownAlignment,
    isOpen: isOpen
  }, chat.mayShow && /*#__PURE__*/React.createElement(Container, {
    id: isChatbotRobbie && isActive(chat == null ? void 0 : (_chat$output = chat.output) == null ? void 0 : _chat$output.status) ? 'livechat-block' : undefined,
    onClick: function onClick() {
      var _chat$output2;

      if (!isChatbotRobbie) {
        openChat();
      }

      if (isChatbotRobbie && !isActive(chat == null ? void 0 : (_chat$output2 = chat.output) == null ? void 0 : _chat$output2.status)) {
        window.location = email.link;
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    p: 4
  }, /*#__PURE__*/React.createElement(ChatInfo, {
    componentData: chat
  }))), phone.mayShow && /*#__PURE__*/React.createElement(Container, {
    onClick: openPhone
  }, /*#__PURE__*/React.createElement(Box, {
    p: 4
  }, /*#__PURE__*/React.createElement(PhoneInfo, {
    componentData: phone
  }))), email.mayShow && /*#__PURE__*/React.createElement(Container, {
    onClick: function onClick() {
      return window.open(email.link);
    }
  }, /*#__PURE__*/React.createElement(Box, {
    p: 4
  }, /*#__PURE__*/React.createElement(EmailInfo, {
    componentData: email
  }))))));
};

export default Header;